var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-ab"},[(_vm.show)?[[_c('summaryingComplete',{attrs:{"status":1,"isZy":true,"type":2}})]]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }